import { render, staticRenderFns } from "./Beer.vue?vue&type=template&id=33d8b897&scoped=true"
import script from "./Beer.vue?vue&type=script&lang=js"
export * from "./Beer.vue?vue&type=script&lang=js"
import style0 from "./Beer.vue?vue&type=style&index=0&id=33d8b897&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d8b897",
  null
  
)

export default component.exports